<ng-container [formGroup]="group" *ngIf="group">
  <div class="hf-input-group">
    <span *ngIf="icon" class="hf-form-control-icon">
      <i class="material-icons">{{ icon }}</i>
    </span>
    <input
      [formControlName]="controlName"
      [name]="fieldName"
      [id]="fieldName"
      [placeholder]="placeholder"
      [autocomplete]="autocomplete"
      [type]="type"
      class="form-control hf-form-control"
      tabindex="0"
    />
  </div>
</ng-container>
